// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3sovF","btn":"styles_btn__3Vt0K","tags":"styles_tags__3Oxvm","wrapBtn":"styles_wrapBtn__3Qjnc","acquiringBtn":"styles_acquiringBtn__3Ms3w"};